'use client';

interface PillProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
}

export function Pill({ children, icon, className = '' }: PillProps) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full bg-accent/8 px-3 py-1 font-body text-[13px] font-medium text-accent-dark ${className}`}
    >
      {icon && <span className="flex shrink-0 items-center">{icon}</span>}
      {children}
    </span>
  );
}
